import { IItemCacheThunkAction, IItemCacheDispatch } from '../../store/actions/ItemCacheActions';
import { childItemsFacet } from '../../facets/SetFacets';
import { createdItemFacet } from '../../facets/ProgressFacets';
import { readItems } from '../../operations/readItems';
import { IItemCache } from '../../models/IItemCacheObserver';

/**
 * @beta
 * @deprecated Use `getRootCreatedItemsFromEntryBatch` within a call to `readItems` or `demandItems`.
 */
export function getEntryBatchRootCreatedItems(payload: {
    progressItemKey: string;
}): IItemCacheThunkAction<{
    itemKeys: string[];
}> {
    const {
        progressItemKey
    } = payload;

    return (dispatch: IItemCacheDispatch) => {
        return {
            itemKeys: dispatch(readItems((itemCache: IItemCache) => {
                const createdItemKeys: string[] = [];

                const childItems = itemCache.demandItemFacet(childItemsFacet, progressItemKey);

                const childProgressItemKeys = childItems && childItems.itemKeys;

                if (childProgressItemKeys) {
                    for (const childProgressItemKey of childProgressItemKeys) {
                        const createdItem = itemCache.demandItemFacet(createdItemFacet, childProgressItemKey);

                        const createdItemKey = createdItem && createdItem.itemKey;

                        if (createdItemKey) {
                            createdItemKeys.push(createdItemKey);
                        }
                    }
                }

                return createdItemKeys;
            }))
        };
    };
}

/**
 * @public
 */
export function getRootCreatedItemsFromEntryBatch(itemCache: IItemCache, props: {
    progressItemKey: string;
}): {
        itemKeys: string[];
    } {
    const createdItemKeys: string[] = [];

    const childItems = itemCache.demandItemFacet(childItemsFacet, props.progressItemKey);

    const childProgressItemKeys = childItems && childItems.itemKeys;

    if (childProgressItemKeys) {
        for (const childProgressItemKey of childProgressItemKeys) {
            const createdItem = itemCache.demandItemFacet(createdItemFacet, childProgressItemKey);

            const createdItemKey = createdItem && createdItem.itemKey;

            if (createdItemKey) {
                createdItemKeys.push(createdItemKey);
            }
        }
    }

    return {
        itemKeys: createdItemKeys
    };
}
